// Configuration file for React app
const config = {
    // Show unused permissions in UI
    SHOW_UNUSED_PERMISSIONS: process.env.REACT_APP_SHOW_UNUSED_PERMISSIONS === 'true' || false,
    // Show AI-related buttons
    AI_ENABLED: process.env.REACT_APP_AI_ENABLED === 'true',
};

export default config; 